import { enumBranchStyle, kPeerAssistBranchGroup, kStdAssistBranchGroup } from "../constants";

export function IsAssistantStyle(branchStyle) {
  var result = null;
  switch (branchStyle) {
    case enumBranchStyle.assistantpeerright:
    case enumBranchStyle.assistantpeerleft:
      result = kPeerAssistBranchGroup;
      break;
    case enumBranchStyle.assistantright:
    case enumBranchStyle.assistantleft:
      result = kStdAssistBranchGroup;
      break;
  }

  return result;
}
